export default __webpack_public_path__ + "assets/images/ilustracao-cadastro-documentos27763fddd53cae246d76de9edd2a8334.png";